import { createInProcessOfSignupStorage } from "../utils/auth/createInProcessOfSignupStorage";

const IS_PROCESS_OF_OIDC_SIGN_UP_STORAGE_KEY = "inProcessOfOIDCSignup";
const IS_PROCESS_OF_OIDC_SIGN_UP_STORAGE__TIME_KEY = "inProcessOfOIDCSignupTime";

const storage = createInProcessOfSignupStorage({
  storageKey: IS_PROCESS_OF_OIDC_SIGN_UP_STORAGE_KEY,
  timeStorageKey: IS_PROCESS_OF_OIDC_SIGN_UP_STORAGE__TIME_KEY,
});

export const setInProcessOfOIDCSignup = (signUp: boolean): void => storage.set(signUp);

export const clearInProcessOfOIDCSignup = (): void => storage.clear();

export const getInProcessOfOIDCSignup = (): boolean => storage.get();
